import React from "react";
import { ShieldCheck } from "lucide-react";

/**
 * AdminOnlyNote - distinct purple panel that signals "this text/control is
 * admin-facing only and never rendered for hosts." Used across the Host
 * Dashboard editor, Launch Control, Master Components, and any admin surface
 * where explainer copy or configuration must be visually separated from
 * host-visible content (Iter 9.40 Slice C⁷).
 *
 * Usage:
 *   <AdminOnlyNote>
 *     This live preview is what a Makeup host sees on /me. Hosts cannot edit
 *     this section directly.
 *   </AdminOnlyNote>
 *
 *   <AdminOnlyNote title="Insights configuration" testid="insights-cfg">
 *     Toggles below decide which buckets appear in the host's live Insights
 *     tab. Hosts never see these toggles.
 *   </AdminOnlyNote>
 */
export default function AdminOnlyNote({
  children,
  title,
  className = "",
  testid = "admin-only-note",
  compact = false,
}) {
  return (
    <div
      className={`relative rounded-lg border border-purple-200 bg-purple-50 ${compact ? "p-2.5" : "p-3"} ${className}`}
      data-testid={testid}
    >
      <div className="absolute -top-2 left-3 inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-purple-600 text-white text-[9px] font-bold uppercase tracking-wider shadow-sm">
        <ShieldCheck className="w-2.5 h-2.5" /> Admin
      </div>
      {title && <h4 className="text-xs font-semibold text-purple-900 mb-1 mt-0.5">{title}</h4>}
      <div className="text-[11px] text-purple-800 leading-relaxed">{children}</div>
    </div>
  );
}
